'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleInitialMessageBubbleClick = undefined;

var _WidgetActions = require('../../actions/WidgetActions');

var _trackUserInteraction = require('../../actions/trackUserInteraction');

var handleInitialMessageBubbleClick = exports.handleInitialMessageBubbleClick = function handleInitialMessageBubbleClick() {
  return function (dispatch) {
    dispatch((0, _WidgetActions.toggleOpen)(true));
    dispatch((0, _trackUserInteraction.trackUserInteraction)());
  };
};